var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_232_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_277_",
    x: 9.85,
    y: 5.32,
    width: 16.15,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_157_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_276_",
    y: 5.32,
    width: 4.73,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_234_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_274_",
    x: 20.99,
    y: 12.43,
    width: 5.01,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_273_",
    y: 12.43,
    width: 15.98,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_235_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_272_",
    x: 9.34,
    y: 19.33,
    width: 16.66,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_173_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_270_",
    y: 19.33,
    width: 4.54,
    height: 1.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_267_",
    d: "M18.16,16.49c-1.81,0-3.28-1.47-3.28-3.28s1.47-3.28,3.28-3.28s3.28,1.47,3.28,3.28 S19.97,16.49,18.16,16.49z M18.16,11.56c-0.91,0-1.66,0.74-1.66,1.66s0.74,1.66,1.66,1.66s1.66-0.74,1.66-1.66 S19.08,11.56,18.16,11.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_188_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_264_",
    d: "M7.2,23.15c-1.81,0-3.28-1.47-3.28-3.28s1.47-3.28,3.28-3.28c1.81,0,3.28,1.47,3.28,3.28 S9,23.15,7.2,23.15z M7.2,18.22c-0.91,0-1.66,0.74-1.66,1.66s0.74,1.66,1.66,1.66s1.65-0.74,1.65-1.66S8.11,18.22,7.2,18.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_261_",
    d: "M7.2,9.41c-1.81,0-3.28-1.47-3.28-3.28S5.39,2.85,7.2,2.85c1.81,0,3.28,1.47,3.28,3.28S9,9.41,7.2,9.41z  M7.2,4.47c-0.91,0-1.66,0.74-1.66,1.66S6.28,7.78,7.2,7.78s1.65-0.74,1.65-1.66S8.11,4.47,7.2,4.47z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/Slider.f75e2ddbc0b1f394c8206829be578542.svg";
export { ForwardRef as ReactComponent };